<template>
    <div>
        <b-modal
            v-model="show"
            @hidden="hiddenModal"
            @shown="shownModal"
            id="shipping-settings"
            :title="title"
            size="xl"
            scrollable
            >
            <b-row>
                <b-col md="6">
                    <!-- Policy title -->
                    <b-form-group
                        label="Policy title *"
                        label-for="shippingRuleTitle">
                        <b-form-input
                            id="shippingRuleTitle"
                            v-model.trim="rule.title"
                            @change="create"></b-form-input>
                    </b-form-group>

                    <!-- Chousen courier -->
                    <b-form-group label="Chousen courier *">
                        <b-form-checkbox-group
                            id="checkbox-couriers"
                            v-model="rule.couriers"
                            :options="couriers"
                            name="couriers"
                            stacked
                        ></b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group
                        class="mt-4"
                        label="Delivery options">
                        <b-form-checkbox
                            class="pt-0"
                            v-for="option in deliveryOptions"
                            v-model="rule.deliveryOptions"
                            :key="option.value"
                            :value="option.value"
                            name="deliveryOptions"
                        >
                            {{option.text}}
                        </b-form-checkbox>
                    </b-form-group>

                    <!-- Service -->
                    <b-form-group
                        class="mt-4"
                        label="Service:">
                        <b-form-radio-group
                            v-model="rule.service"
                            :options="service"
                            name="radio-inline"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-row align-v="end">
                        <b-col md="6">
                            <label>By product's value</label>
                            <b-form-select
                                v-model="byValueProduct.selected"
                                :options="selectOptions"
                                class="mb-3"
                            ></b-form-select>
                        </b-col>
                        <b-col md="5">
                            <div class="form-group">
                                <div v-if="Object.keys(rule.byValueProduct)[0] === 'between'" class="form-row align-items-center">
                                    <div class="col-5">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            v-model.number="rule.byValueProduct[Object.keys(rule.byValueProduct)[0]][0]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-5">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            v-model.number="rule.byValueProduct[Object.keys(rule.byValueProduct)[0]][1]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-2">
                                        (€)*
                                    </div>
                                </div>
                                <div v-else class="form-row align-items-center">
                                    <div class="col-10">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            :value="parseInt(rule.byValueProduct[Object.keys(rule.byValueProduct)[0]][0], 10)"
                                            v-model.number="rule.byValueProduct[Object.keys(rule.byValueProduct)[0]][0]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-2">
                                        (€)*
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row align-v="end">
                        <b-col md="6">
                            <label>By delivery price</label>
                            <b-form-select
                                v-model="byPriceDelivery.selected"
                                :options="selectOptions"
                                class="mb-3"
                            ></b-form-select>
                        </b-col>
                        <b-col md="5">
                            <div class="form-group">
                                <div v-if="Object.keys(rule.byPriceDelivery)[0] === 'between'" class="form-row align-items-center">
                                    <div class="col-5">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            v-model.number="rule.byPriceDelivery[Object.keys(rule.byPriceDelivery)[0]][0]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-5">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            v-model.number="rule.byPriceDelivery[Object.keys(rule.byPriceDelivery)[0]][1]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-2">
                                        (€)*
                                    </div>
                                </div>
                                <div v-else class="form-row align-items-center">
                                    <div class="col-10">
                                        <b-form-input
                                            type="number"
                                            min="0"
                                            v-model.number="rule.byPriceDelivery[Object.keys(rule.byPriceDelivery)[0]][0]"
                                        ></b-form-input>
                                    </div>
                                    <div class="col-2">
                                        (€)*
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <hr>
                    <!-- Set additional insurance for total parcel value: -->
                    <b-form-group class="mt-2" label="Set additional insurance for total parcel value:">
                        <b-form-radio v-for="(option, index) in insurance.base.options"
                                    :key="index"
                                    v-model="rule.insuranceAlways"
                                    :value="option.value"
                                    @change="resetInsuranceDetail"
                                    class="pt-2">
                            {{option.text}}
                        </b-form-radio>

                        <div class="pl-4 pt-2" :class="{'disabled': rule.insuranceAlways}">
                            <b-form-group label="When delivery courier is:">
                                <b-form-checkbox-group
                                    id="checkbox-insurance-couriers"
                                    v-model="rule.insuranceDetail.couriers"
                                    :options="insurance.detailed.couriers.options"
                                    stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                            <b-row align-v="end">
                                <b-col md="6">
                                    <label>When parsel's value is:</label>
                                    <b-form-select
                                        v-model="byParcelValue.selected"
                                        :options="selectOptions"
                                        class="mb-3"
                                    ></b-form-select>
                                </b-col>
                                <b-col md="5">
                                    <div class="form-group">
                                        <div v-if="Object.keys(rule.byParcelValue)[0] === 'between'" class="form-row align-items-center">
                                            <div class="col-5">
                                                <b-form-input
                                                    type="number"
                                                    min="0"
                                                    v-model.number="rule.byParcelValue[Object.keys(rule.byParcelValue)[0]][0]"
                                                ></b-form-input>
                                            </div>
                                            <div class="col-5">
                                                <b-form-input
                                                    type="number"
                                                    min="0"
                                                    v-model.number="rule.byParcelValue[Object.keys(rule.byParcelValue)[0]][1]"
                                                ></b-form-input>
                                            </div>
                                            <div class="col-2">
                                                (€)*
                                            </div>
                                        </div>
                                        <div v-else class="form-row align-items-center">
                                            <div class="col-10">
                                                <b-form-input
                                                    type="number"
                                                    min="0"
                                                    v-model.number="rule.byParcelValue[Object.keys(rule.byParcelValue)[0]][0]"
                                                ></b-form-input>
                                            </div>
                                            <div class="col-2">
                                                (€)*
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-form-group
                                class="mt-4"
                                label="When delivery is:">
                                <b-form-checkbox-group
                                    v-model="rule.insuranceDetail.deliveryType"
                                    :options="insurance.detailed.deliveryType.options"
                                    stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                            <b-form-group
                                class="mt-4"
                                label="When delivery service type is:">
                                <b-form-checkbox-group
                                    v-model="rule.insuranceDetail.deliveryServiceType"
                                    :options="insurance.detailed.deliveryServiceType.options"
                                    stacked
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-button
                        class="mb-3"
                        variant="primary-user"
                        size="sm" @click="showProductsList"
                        :disabled="rule.title === ''">
                            {{buttonText}}
                    </b-button>
                    <b-button
                        v-b-modal.shipping-settings-products-list
                        v-if="rule.products.length > productsLimit"
                        class="mb-3 ml-1"
                        variant="outline-user-primary"
                        size="sm">Open full added products list</b-button>
                    <RuleProductsList :products="rule.products" :limit="productsLimit"/>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button
                    variant="primary-user"
                    size="sm"
                    @click="save"
                    :disabled="rule.title === ''"
                    >
                        Save
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="shipping-settings-products-list"
            :title="`Shipping rule: ${rule.title.toLowerCase()}`"
            size="xl"
            hide-footer
            scrollable
        >
            <RuleProductsList :products="rule.products" />
        </b-modal>
    </div>
</template>

<script>
    import ShippingRule from './../services/ShippingRule'
    import RuleProductsList from './RuleProductsList'
    export default {
        name: 'ShippingSettingsModal',
        props: ['ruleId'],
        data() {
            return {
                show: false,
                productsLimit: 5,
                rule: new ShippingRule(),
                saveState: false,
                selectOptions: [
                    { value: 'between', text: 'between' },
                    { value: 'equal_to', text: 'equal to' },
                    { value: 'greater_than', text: 'greater than' },
                    { value: 'less_than', text: 'less than' },
                    { value: 'greater_than_or_equal_to', text: 'greater than or equal to' },
                    { value: 'less_than_or_equal_to', text: 'less than or equal to' }
                ],
                couriers: [],
                allCouriers: [],
                insuranceDetailedDefault: {},
                deliveryOptions: [
                    { text: 'For domestic delivery', value: 'delivery_domestic' },
                    { text: 'For delivery to EU countries', value: 'delivery_eu' },
                    { text: 'For delivery to non EU countries', value: 'delivery_non_eu' }
                ],
                byPriceDelivery: {
                    selected: 'between',
                    unwatcher: null
                },
                byValueProduct: {
                    selected: 'between',
                    unwatcher: null
                },
                byParcelValue: {
                    selected: 'between',
                    unwatcher: null
                },
                service: [
                    { text: 'Cheapest', value: 'cheapest' },
                    { text: 'Fastest', value: 'fastest' }
                ],
                insurance: {
                    base: {
                        options: [
                            { text: 'Always', value: true },
                            { text: 'Detailed setup', value: false },
                        ]
                    },
                    detailed: {
                        couriers: {
                            // selected: null,
                            options: [
                                { text: 'DHL Economy', value: '41' },
                                { text: 'DHL Import Express', value: '45' },
                            ]
                        },
                        deliveryType: {
                            // selected: null,
                            options: [
                                { text: 'For domestic delivery', value: 'delivery_domestic' },
                                { text: 'For delivery to EU countries', value: 'delivery_eu' },
                                { text: 'For delivery to non EU countries', value: 'delivery_non_eu' }
                            ]
                        },
                        deliveryServiceType: {
                            // selected: null,
                            options: [
                                { text: 'Economy', value: 'economy' },
                                { text: 'Express', value: 'express' },
                            ]
                        }
                    }
                }
            }
        },
        components: {
            RuleProductsList
        },
        computed: {
            title() {
                return !this.ruleId ? 'Create Shipinng policy' : 'Edit Shipping policy'
            },
            buttonText() {
                return 'Add product'
            },
            getRuleId() {
                if (this.$route.params.ruleId && !this.ruleId) {
                    return this.$route.params.ruleId
                } else {
                    return this.ruleId
                }
            }
        },
        created() {
            this.fetchCouriers()
            if (this.$route.params.ruleId && !this.ruleId) {
                this.show = true
            }
            this.insuranceDetailedDefault = {
                couriers: ['41', '45'],
                deliveryType: ['delivery_domestic', 'delivery_eu', 'delivery_non_eu'],
                deliveryServiceType: ['economy', 'express']
            }
        },
        methods: {
            setSelectWatcher(key) {
                this[key].unwatcher = this.$watch(`${key}.selected`, (val) => {
                    if (val !== 'between') {
                        this.$set(this.rule, key, this.rule.setQuantityFields(key, this[key].selected, 1))
                    } else {
                        this.$set(this.rule, key, this.rule.setQuantityFields(key, this[key].selected, 2))
                    }
                })
            },
            resetInsuranceDetail() {
                Object.assign(this.$data.rule, {
                    insuranceDetail: !this.rule.insuranceAlways ? this.$options.data().rule.insuranceDetail : this.insuranceDetailedDefault
                })
                Object.assign(this.$data.byParcelValue, {
                    selected: this.$options.data().byParcelValue.selected,
                })
            },
            fetchRule() {
                // TODO: waiting from API
                // Dummy object
                return this.$store.state.shippingPolicyState.shippingPolicyList.find(item => item.id === this.getRuleId)
            },
            fetchCouriers() {
                this.$api('GET', this.$endpoints.deliveryServices).then(response => {
                    this.couriers = response.map(courier => {
                        this.allCouriers.push(courier.code)
                        return {
                            text: courier.name,
                            value: courier.code
                        }
                    })
                })
            },
            showProductsList() {
                this.$router.push({name: 'ShippingPolicyAddProduct', params: {name: this.rule.title, id: this.rule.id}})
            },
            create() {
                this.$store.commit('ADD_RULE', this.rule)
                this.saveState = true
            },
            save() {
                this.$store.commit('EDIT_RULE', this.rule)
                this.show = false
            },
            shownModal() {
                if (this.ruleId || this.$route.params.ruleId) {
                    this.rule = new ShippingRule(this.fetchRule())
                    this.courier = this.rule.courier
                    this.byPriceDelivery.selected = Object.keys(this.rule.byPriceDelivery)[0]
                    this.byValueProduct.selected = Object.keys(this.rule.byValueProduct)[0]
                    this.byParcelValue.selected = Object.keys(this.rule.byParcelValue)[0]
                }
                if (this.rule.couriers.length < 1) {
                    this.rule.couriers = this.allCouriers
                }
                this.setSelectWatcher('byPriceDelivery')
                this.setSelectWatcher('byValueProduct')
                this.setSelectWatcher('byParcelValue')
            },
            hiddenModal() {
                this.byPriceDelivery.unwatcher()
                this.byValueProduct.unwatcher()
                this.byParcelValue.unwatcher()
                this.$route.params.ruleId = ''
                Object.assign(this.$data, {
                    rule: this.$options.data().rule,
                    byPriceDelivery: this.$options.data().byPriceDelivery,
                    byValueProduct: this.$options.data().byValueProduct,
                    byParcelValue: this.$options.data().byParcelValue,
                    insurance: this.$options.data().insurance
                })
            }
        },
    }
</script>

<style lang="scss">
    #shipping-settings {
        label:not(.custom-control-label),
        .col-form-label {
            padding-left: 0;
            font-weight: bold;
        }
        #checkbox-couriers {
            max-height: 400px;
            overflow-y: auto;
        }
        .disabled {
            pointer-events: none;
            opacity: 0.7;
        }
    }
    .sp-service-logo {
        margin-left: .5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ShippingPolicySettings/components/ShippingSettingsModal.vue